export const pageInfo = {
	home: { title: 'Home' },
	infoSetting: {
		title: 'Info Setting',
		subPages: {
			operatorInfo: { title: 'Operator Info' },
			gameProviderInfo: { title: 'Game Provider Info' },
			gameInfoManage: { title: 'Game Info' },
			subLineRequisitions: { title: 'Sub-Line Requisitions' },
			subLineInfos: { title: 'Sub-Line Infos' },
			operatorOnboard: { title: 'Operator onboard & manage' },
			cacheInfo: { title: 'Cache Info' },
			operatorFamily: { title: 'Operator Family' },
		},
	},
	bet: {
		title: 'Bet',
		subPages: {
			searchRunningBet: { title: 'Search Running Bet' },
			manageBetList: { title: 'Manage Bet List' },
			betTool: { title: 'Tool' },
		},
	},
	maintainHistory: { title: 'Maintain History' },
	exchangeRate: { title: 'Exchange Rate' },
	lobby: {
		title: 'Lobby',
		subPages: {
			lobbyGameToggle: { title: 'Game Toggle' },
			lobbySettingTemplate: { title: 'Setting Template' },
			lobbyBannerManage: { title: 'Banner Management', hideFromNav: true },
			lobbyTopOneManage: { title: 'Top1 Management', hideFromNav: true },
			lobbyOpGameList: { title: 'Op Lobby Game List' },
		},
	},
	gameListSetting: {
		title: 'Game List Setting',
		subPages: {
			gameSetting: { title: 'Game Setting' },
			gameCertFiles: { title: 'Game Cert Files' },
			orderSetting: { title: 'Order Setting' },
			gameTypeMapping: { title: 'Mapping List' },
			gameListTemplate: { title: 'Template List' },
			operatorSetting: { title: 'Operator Templates' },
			opGameList: { title: 'Op Game List' },
		},
	},
	voucherEvents: { title: 'Voucher Events' },
	gameRisk: {
		title: 'Game Risk',
		subPages: {
			playerRiskLevels: { title: 'Player Risk Levels' },
			gameTotalRiskLevels: { title: 'Game Total Risk Levels' },
			gameRiskMapping: { title: 'Game Risk Mapping' },
			riskBlacklist: { title: 'Black List' },
		},
	},
};

export const navStatusList = {
	needChecked: 'needChecked',
	none: 'none',
};

export const pageStatusList = Object.entries(pageInfo).reduce((_result, [key, value]) => {
	if (!value.subPages) {
		return { ..._result, [key]: navStatusList.none };
	}
	return Object.keys(value.subPages).reduce(
		(_resultWithSubPage, path) => ({
			..._resultWithSubPage,
			[path]: navStatusList.none,
		}),
		{ ..._result }
	);
}, {});

export const pageTitle = (pathname) => {
	const key = pathname.split('/')[1];
	if (!key) return '';

	const page = pageInfo[key];
	if (page) {
		return page.title;
	}

	return extractSubPageTitle(key);
};

function extractSubPageTitle(key) {
	for (const page of Object.values(pageInfo)) {
		if (page.subPages && page.subPages[key]) {
			return `${page.title} / ${page.subPages[key].title}`;
		}
	}
	return '';
}

/** True when `pathname` is the page at `path` or one of its child routes (e.g. `gameListTemplate/manage`). */
export const isActivePath = (path, pathname) => {
	const current = pathname.replace(/^\/+/, '');
	return current === path || current.startsWith(`${path}/`);
};

export const groupContainsPath = (subPages, pathname) =>
	Object.keys(subPages).some((path) => isActivePath(path, pathname));

/** Menu entries whose page or group title contains every word of `query`, in menu order. */
export const searchPages = (query) => {
	const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
	if (!words.length) return [];

	const entries = Object.entries(pageInfo).flatMap(([key, page]) => {
		if (page.hideFromNav) return [];
		if (!page.subPages) return [{ path: key, title: page.title, group: '' }];
		return Object.entries(page.subPages)
			.filter(([, subPage]) => !subPage.hideFromNav)
			.map(([path, subPage]) => ({ path, title: subPage.title, group: page.title }));
	});

	return entries.filter(({ title, group }) => {
		const text = `${group} ${title}`.toLowerCase();
		return words.every((word) => text.includes(word));
	});
};

export const listNavGroups = () => {
	const standalone = [];
	const groups = [];
	Object.entries(pageInfo).forEach(([key, page]) => {
		if (page.hideFromNav || key === 'home') return;
		if (!page.subPages) {
			standalone.push({ path: key, title: page.title });
			return;
		}
		const pages = Object.entries(page.subPages)
			.filter(([, subPage]) => !subPage.hideFromNav)
			.map(([path, subPage]) => ({ path, title: subPage.title }));
		if (pages.length) groups.push({ title: page.title, pages });
	});
	return standalone.length ? [...groups, { title: 'Other', pages: standalone }] : groups;
};

export const findNavEntry = (pathname) => {
	const key = pathname.split('/')[1];
	return listNavGroups()
		.flatMap(({ title, pages }) => pages.map((page) => ({ ...page, group: title })))
		.find(({ path }) => path === key);
};
